type CometPermissions = {
  actionTracker: number
  assured: number
  expertExtensions: number
  incidentManagement: number
  investigate: number
}

export default class UserModel {
  public userId: string = ''
  public firstname: string = ''
  public lastname: string = ''
  public role: string = ''
  public roleDescription: string = ''
  public enabled: boolean = false
  public companyId: string = ''
  public permissions: CometPermissions = {
    actionTracker: 0,
    assured: 0,
    expertExtensions: 0,
    incidentManagement: 0,
    investigate: 0
  }

  constructor(data?: any) {
    if (data) {
      Object.assign(this, data)
    }
  }
}
